<template>
  <div>
    <div class="mb-1" v-if="quickLinkData.participants_list">
      <a
        class="typo-color-blue bold-16"
        :href="fetchLegacyUrl(`/${type}/${this.$route.params.id}/registrations`)"
      >
      <b-badge variant="primary">{{quickLinkData.participants_list_count}}</b-badge> Participants List
      </a>
    </div>
  </div>
  </template>

  <script>
  import mixin from '@/utils/mixin.js'

  export default {
    name: 'SeminarQuickLinkSection',
    mixins: [mixin],
    props: ['type', 'quick-link-data']
  }
  </script>
